import { observer } from "mobx-react";
import * as React from "react";

import { ListShockEvents } from "../ui/molecules/list-shock-events";
import { Section } from "../ui/atoms/section";
import { SelectionMode } from "@fluentui/react";
import sizes from "../ui/sizes.scss";
import { store } from "../store";
import { articles } from "../help";
import { FusionLayout } from "@/parts/fusion-layout";

@observer
export class PageImpactManagement extends React.Component {
    public render(): JSX.Element {
        return (
            <FusionLayout
                suggestedHelpArticles={[articles.impactStatisticsReport]}
                breadcrumb={store.i18n.t("page.impactManagement.title")}
                classic
            >
                <Section fill>
                    <ListShockEvents
                        selectionMode={SelectionMode.none}
                        maxHeight={`${sizes.listMaxHeight}`}
                    />
                </Section>
            </FusionLayout>
        );
    }
}
